import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebApiService } from './web-api.service';
import { Tournament, CreateTournamentRequest, TournamentListFilters, MyTournament, TournamentRegistration, RegisterRequest, Bracket, SubmitResultRequest } from '../model/tournament';

@Injectable({ providedIn: 'root' })
export class TournamentService {
  private readonly endpoint = 'Tournament';

  constructor(private http: WebApiService) {}

  list(filters: TournamentListFilters): Observable<Tournament[]> {
    const parts: string[] = [];
    if (filters.clubId != null)      parts.push(`clubId=${filters.clubId}`);
    if (filters.status != null)      parts.push(`status=${filters.status}`);
    if (filters.upcomingOnly)        parts.push(`upcomingOnly=true`);
    const qs = parts.length ? `?${parts.join('&')}` : '';
    return this.http.get(`${this.endpoint}${qs}`);
  }

  getById(id: number): Observable<Tournament> {
    return this.http.get(`${this.endpoint}/${id}`);
  }

  create(body: CreateTournamentRequest): Observable<Tournament> {
    return this.http.post(this.endpoint, body);
  }

  register(id: number, partnerId?: number): Observable<TournamentRegistration> {
    const body: RegisterRequest = partnerId != null ? { partner_id: partnerId } : {};
    return this.http.post(`${this.endpoint}/${id}/Register`, body);
  }

  confirmRegistration(id: number, registrationId: number): Observable<TournamentRegistration> {
    return this.http.post(`${this.endpoint}/${id}/Registration/Confirm`, { registration_id: registrationId });
  }

  cancelRegistration(id: number): Observable<void> {
    return this.http.post(`${this.endpoint}/${id}/Registration/Cancel`, {});
  }

  getMine(): Observable<MyTournament[]> {
    return this.http.get(`${this.endpoint}/Mine`);
  }

  getBracket(id: number): Observable<Bracket> {
    return this.http.get(`${this.endpoint}/${id}/Bracket`);
  }

  draw(id: number): Observable<void> {
    return this.http.post(`${this.endpoint}/${id}/Draw`, {});
  }

  submitResult(matchId: number, body: SubmitResultRequest): Observable<void> {
    return this.http.post(`${this.endpoint}/Match/${matchId}/Result`, body);
  }

  edit(id: number, body: CreateTournamentRequest): Observable<Tournament> {
    return this.http.put(`${this.endpoint}/${id}`, body);
  }

  cancelTournament(id: number): Observable<void> {
    return this.http.post(`${this.endpoint}/${id}/Cancel`, {});
  }
}
